import React from "react";
import styled from "styled-components/macro";
import { ResourceStrings } from "../../ResourceStrings";
import { useHistory } from "react-router-dom";
import { Breadcrumb, IBreadcrumbItem } from "@fluentui/react/lib/Breadcrumb";
import * as Actions from "../../store/actions";
import { RootState } from "../../store/rootState";
import { Dialog } from "../../store/appState";
import { useSelector } from "react-redux";
import { AppPaths } from "../../constants/urls";

export default function BreadcrumbComponent(): JSX.Element {
    const state = useSelector((state: RootState) => state.appState);
    const history = useHistory();

    const appPath: AppPaths = history.location.pathname as AppPaths;
    const joinOngoingDiscussion: boolean = state.dialog === Dialog.comment && appPath === AppPaths.report;

    const onGoBack = (): void => {
        Actions.setDialog(Dialog.none);
        history.goBack();
    };

    const items: IBreadcrumbItem[] = [
        { text: ResourceStrings.reportAProblem(), key: 'rap', onClick: onGoBack },
        { text: ResourceStrings.voteForAProblem(), key: 'vote' }
    ];

    if (joinOngoingDiscussion) {
        return <Wrapper>
            <div>
                <Breadcrumb items={items} />
            </div>
        </Wrapper>
    }

    return null;
}

const Wrapper = styled.div`
    display: flex;
    justify-content: center;

    &> div {
        width: 100%;
        padding: 0 3rem;
    }

    & * {
        font-size: 1.6rem;
    }

    .ms-Breadcrumb-itemLink {
        color: var(--color-on-surface-link);
    }

    .ms-Breadcrumb-chevron {
        font-size: 1.2rem;
    }
`;
